import React from "react";
import GrowthBadge from "./GrowthBadge";
import { fmtINR } from "../../utils/formatters";
import { MEDAL_COLORS, T } from "../../constants/theme";

/** Top selling company row — horizontal leaderboard layout. */
const TopCompanyRow = ({ company, rank, maxSale, loading }) => {
  const pct = maxSale > 0 ? Math.max(2, Math.round((company.sale / maxSale) * 100)) : 0;
  const isMedal = rank <= 3;
  const dotColor = isMedal ? MEDAL_COLORS[rank - 1] : T.light;
  const dotText = isMedal ? "#fff" : T.muted;

  return (
    <div className="sad-company-row">
      <div className="sad-rank-dot" style={{ background: dotColor, color: dotText }}>
        {rank}
      </div>

      <div className="sad-company-main">
        <div className="sad-company-row-top">
          <span className="sad-company-name" title={company.name}>
            {company.name}
          </span>
          {company.badge && <span className="sad-company-tag">{company.badge}</span>}
        </div>
        <div className="sad-company-track" title={`${pct}% of top seller`}>
          <div className="sad-company-fill" style={{ width: loading ? "0%" : `${pct}%` }} />
        </div>
      </div>

      <div className="sad-company-end">
        <div className="sad-company-sale">{loading ? "…" : fmtINR(company.sale)}</div>
        <GrowthBadge value={company.growth} />
      </div>
    </div>
  );
};

export default TopCompanyRow;
